export { default, BibListItem } from './BibListItem';



// WEBPACK FOOTER //
// ./app/components/shared/BibListItem/index.js